import builder from '../builder';
import DownloadBottomIcon from '../../streamline-icons/bold/download-bottom.svg';

export default builder('Download', DownloadBottomIcon);
